import React from 'react'
import { Redirect } from '@reach/router'
import Group from './group'
import { createGroupId } from './helpers'
import useGalleryNavigation from './hooks/use-gallery-nav'

const Section = ({ groups, templates, groupId, subgroupId, ...rest }) => {
  const { createPath } = useGalleryNavigation()
  const group = groups.find(g => createGroupId(g.name) === groupId)
  const groupTemplates = templates.filter(
    t =>
      createGroupId(t.group) === groupId &&
      (!subgroupId || createGroupId(t.subgroup) === subgroupId),
  )

  if (!group || !templates.length) {
    return <Redirect to={createPath()} noThrow />
  }

  const subgroup =
    subgroupId &&
    group.subgroups.find(sg => createGroupId(sg.name) === subgroupId)

  return groupTemplates.length > 0 ? (
    <Group
      group={group}
      subgroup={subgroup}
      templates={groupTemplates}
      {...rest}
    />
  ) : null
}

export default Section
